import { Embed } from '@mentimeter/ragnar-ui/embed';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Text } from '@mentimeter/ragnar-ui/text';
import { SubHeading, Meta } from '@mentimeter/ragnar-ui/typography';

const HOW_TO_VIDEOS = [
  {
    title: 'How to create a word cloud',
    src: 'https://www.youtube-nocookie.com/embed/jHfOIwn-tnc',
    description:
      'Learn how to make dynamic word clouds in Mentimeter to visualize your audience’s input - in real time.',
  },
  {
    title: 'How to Use Mentimeter in PowerPoint',
    src: 'https://www.youtube-nocookie.com/embed/xA409AX5Zb0',
    description:
      'See how to seamlessly integrate Mentimeter into your PowerPoint slides and boost engagement without switching tools.',
  },
  {
    title: 'How to Create a Survey in Minutes',
    src: 'https://www.youtube-nocookie.com/embed/0Cpn_laGOtM',
    description:
      'Quickly build and share surveys using Mentimeter’s easy tools—perfect for collecting insights asynchronously.',
  },
  {
    title: 'How to create a Q&A',
    src: 'https://www.youtube-nocookie.com/embed/CvYvXwf1tqQ',
    description:
      'Set up a live Q&A session in Mentimeter to let your audience ask questions and vote on what matters most.',
  },
];

export const HowTo = () => (
  <>
    {HOW_TO_VIDEOS.map((v, i) => (
      <Box
        key={v.title}
        alignItems="stretch"
        flexDirection={['column-reverse', null, 'row-reverse']} // reversed so headings are before videos in a11y tree
        width="100%"
        mt={i !== 0 ? 4 : 0}
      >
        <Box
          ml={[0, null, 3]}
          mt={[3, null, 0]}
          justifyContent="center"
          flex="1 1 auto"
          width={1}
        >
          <SubHeading as="h3">{v.title}</SubHeading>
          <Meta>{v.description}</Meta>
        </Box>
        <Box width={[1, null, 1 / 2]}>
          <Embed title={v.title} src={v.src} allowFullScreen />
        </Box>
      </Box>
    ))}
    <Box mt={4} width="100%" alignItems="center">
      <Text>
        More video tutorials? Check our{' '}
        <Link
          href="https://www.youtube.com/c/Mentimeter-interact-with-your-audience/playlists"
          target="_blank"
          rel="noopener noreferrer"
        >
          Youtube channel
        </Link>
      </Text>
    </Box>
  </>
);
